import { Component } from '@angular/core';
import { NavController, ViewController,NavParams } from 'ionic-angular';

@Component({
  selector: 'page-add-item',
  templateUrl: 'add-item.html'
})
export class AddItemPage {

  ar_id:string;
  priority:string;
  template_text: string;
  isActive:boolean;
  item: any;
  template_id:string;
  index:number;

  constructor(public navCtrl: NavController, public view: ViewController,public navParams: NavParams,) {
      var item = this.navParams.get('item') ;
      if (item != null){
      this.template_text = item.template_text;
      this.template_id = item.template_id;
      this.ar_id = item.ar_id;
      this.priority = item.priority;
      this.isActive = item.isActive;
      console.log("Got Item:",item);
      this.index = this.navParams.get('index') ;
      console.log("Index is:",this.index);
    }
  }

  saveItem(){
    console.log("Save the updates:",this.template_text);
    let newItem = {
      template_id:this.template_id,
      template_text: this.template_text,
      ar_id:'',
      priority:'',
      isActive:1,
      index:this.index,

    };

    this.view.dismiss(newItem);

  }

  close(){
    this.view.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/pages/add-item/add-item.ts